export const WRONG_EMAIL = "Mail is not valid";
export const WRONG_PASSWORD =
  "Password must have at least 1 number, 1 alphabet, 1 special character";
export const WRONG_PHONE_NUMBER = "Enter vaild phone number";
export const WRONG_FULLNAME = "Enter vaild Name";
export const WRONG_SUBJECT = "Enter the valid subject";
